module.exports = __webpack_public_path__ + "img/trunk-dunk-outcome.aac12cad.jpg";